import React, { useContext } from "react";
import { Modal } from "react-bootstrap";

import UserContext from "../context/userContext";

const SiteModal = ({ show, onHide, handleSiteChange }) => {
  const [user] = useContext(UserContext);
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>Change Site</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col justify-content-center">
            <button
              onClick={() => handleSiteChange("BA")}
              className="btn btn-success btn-lg btn-block py-3 m-1"
              disabled={user.SITE === "BA" || !user.ACCESS_BA}
            >
              Bardney
            </button>
          </div>
          <div className="col justify-content-center">
            <button
              onClick={() => handleSiteChange("BU")}
              className="btn btn-success btn-lg btn-block py-3 m-1"
              disabled={user.SITE === "BU" || !user.ACCESS_BU}
            >
              Bury
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <button
              onClick={() => handleSiteChange("CA")}
              className="btn btn-success btn-lg btn-block py-3 m-1"
              disabled={user.SITE === "CA" || !user.ACCESS_CA}
            >
              Cantley
            </button>
          </div>
          <div className="col">
            <button
              onClick={() => handleSiteChange("NE")}
              className="btn btn-success btn-lg btn-block py-3 m-1"
              disabled={user.SITE === "NE" || !user.ACCESS_NE}
            >
              Newark
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <button
              onClick={() => handleSiteChange("WI")}
              className="btn btn-success btn-lg btn-block py-3 m-1"
              disabled={user.SITE === "WI" || !user.ACCESS_WI}
            >
              Wissington
            </button>
          </div>
          <div className="col">
            <button
              onClick={() => handleSiteChange("CO")}
              className="btn btn-success btn-lg btn-block py-3 m-1"
              disabled={user.SITE === "CO" || !user.ACCESS_CO}
            >
              Central Office
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SiteModal;
